import {connect} from "react-redux";
import MatchBlock from "~/components/HorizontalMatchPageLayout/MatchBlock";

function mapStateToProps(state) {
    return {
        allStrategies: state.matchingStrategy.originalAllStrategies,
    };
}

const mapDispatchToProps = {
    //
};

export default connect(mapStateToProps, mapDispatchToProps)(MatchBlock);
